import React, { Component } from "react";
import firebase from "./../../config/firebase";
import "../../Sidebar.css";
import Sidebar from "./../../config/Sidebar";
// import { update_user } from '../../store/actions/actions';
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import Navigations from "./../../config/navbarAdmin";
import "../../screens/Admin/styles.css";
// import '../../config/scripts'
class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blogs: [],
      books: [],
      download: [],
      project: [],
      displayEmail: "",
      uid: "",
      loginUser: this.props.user.user.uid,
    };
  }

  async componentDidMount() {
    this.blogData();
    this.bookData();
    this.downloadData();
    this.projectData();
    // this.authListener();
    // console.log("this.props in Admin", this.props.user)
  }

  authListener() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // console.log("user changed..", user);
        this.setState({
          uid: user.uid,
          displayEmail: user.email,
        });
      } else {
        // No user is signed in.
        // browserHistory.push("/signin");
      }
    });
  }
  blogData = () => {
    this.firebaseRef = firebase.database().ref("BlogData");
    this.firebaseRef.on("value", (snapshot) => {
      let message = snapshot.val();
      // console.log(message)
      var newArr = [];
      for (let word in message) {
        // console.log(message[word].pushKey);
        newArr.push({
          createAt: message[word].createAt,
          newPostKey: message[word].newPostKey,
          heading: message[word].heading,
          description: message[word].description,
          downloadURL: message[word].downloadURL,
        });
      }
      // console.log(message);
      // // arr.push(message)
      this.setState({ blogs: newArr });
    });
  };

  bookData = () => {
    this.firebaseRef = firebase.database().ref("Books");
    this.firebaseRef.on("value", (snapshot) => {
      let message = snapshot.val();

      var newArr = [];
      for (let word in message) {
        newArr.push({
          createAt: message[word].createAt,
          newPostKey: message[word].newPostKey,
          bookName: message[word].bookName,
          category: message[word].category,
          author: message[word].author,
          buttonLink: message[word].buttonLink,
          downloadURL: message[word].downloadURL,
        });
      }
      // console.log(message);
      // // arr.push(message)
      this.setState({ books: newArr });
    });
  };
  downloadData = () => {
    this.firebaseRef = firebase.database().ref("Downloads");
    this.firebaseRef.on("value", (snapshot) => {
      let message = snapshot.val();
      // console.log(message)
      var newArr = [];
      for (let word in message) {
        // console.log(message[word].pushKey);
        newArr.push({
          createAt: message[word].createAt,
          newPostKey: message[word].newPostKey,
          fileName: message[word].fileName,
          body: message[word].body,

          buttonLink: message[word].buttonLink,
          downloadURL: message[word].downloadURL,
        });
      }
      // console.log(message);
      // // arr.push(message)
      this.setState({ download: newArr });
    });
  };
  projectData = () => {
    this.firebaseRef = firebase.database().ref("Projects");
    this.firebaseRef.on("value", (snapshot) => {
      let message = snapshot.val();
      // console.log(message)
      var newArr = [];
      for (let word in message) {
        // console.log(message[word].pushKey);
        newArr.push({
          createAt: message[word].createAt,
          newPostKey: message[word].newPostKey,
          headingName: message[word].headingName,
          description: message[word].description,
          githubLink: message[word].githubLink,
          buttonLink: message[word].buttonLink,
          downloadURL: message[word].downloadURL,
        });
      }
      // console.log(message);
      // // arr.push(message)
      this.setState({ project: newArr });
    });
  };

  render() {
    const { blogs, books, download, project, loginUser } = this.state;
    const { dwOpen } = this.props;
    if (!loginUser) return <Redirect to="/login" />;
    return (
      <div class={dwOpen ? "sb-nav-fixed " : "sb-nav-fixed sb-sidenav-toggled"}>
        <Navigations />
        <div id="layoutSidenav">
          <Sidebar />
          <div id="layoutSidenav_content">
            <main>
              <div class="container-fluid">
                {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}> */}

                <div class="d-flex align-items-center">
                  <h1 class="mt-4">Dashboard</h1>
                  {project.length === 0 ? (
                    <div
                      class="spinner-border ml-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                  ) : null}
                </div>
                {/* <ol class="breadcrumb mb-4">
                                    <li class="breadcrumb-item active">Dashboard</li>
                                </ol> */}

                <div class="row">
                  <div class="col-xl-3 col-md-6">
                    <div class="bg-primary text-white mb-4">
                      <div class="card-body">Blogs</div>
                      <div class="card-footer d-flex align-items-center justify-content-end">
                        <span class="text-white stretched-link">
                          {blogs.length}
                        </span>
                        {/* <div class="small text-white"><i class="fas fa-angle-right"></i></div> */}
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-6">
                    <div
                      class="text-white mb-4"
                      style={{ backgroundColor: "#caa022 " }}
                    >
                      <div class="card-body">Books</div>
                      <div class="card-footer d-flex align-items-center justify-content-end">
                        <span class="small text-white stretched-link">
                          {books.length}
                        </span>
                        {/* <div class="small text-white"><i class="fas fa-angle-right"></i></div> */}
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-6">
                    <div class=" bg-success text-white mb-4">
                      <div class="card-body">Downloads</div>
                      <div class="card-footer d-flex align-items-center justify-content-end">
                        <span class="small text-white stretched-link">
                          {download.length}
                        </span>
                        {/* <div class="small text-white"><i class="fas fa-angle-right"></i></div> */}
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-6">
                    <div class=" bg-danger text-white mb-4">
                      <div class="card-body">Projects</div>
                      <div class="card-footer d-flex align-items-center justify-content-end">
                        <span class="small text-white stretched-link">
                          {project.length}
                        </span>
                        {/* <div class="small text-white"><i class="fas fa-angle-right"></i></div> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div class="row">
                                    <div class="col-xl-6">
                                        <div class="card mb-4">
                                            <div class="card-header"><i class="fas fa-chart-area mr-1"></i>Area Chart Example</div>
                                            <div class="card-body"><canvas id="myAreaChart" width="100%" height="40"></canvas></div>
                                        </div>
                                    </div>
                                    <div class="col-xl-6">
                                        <div class="card mb-4">
                                            <div class="card-header"><i class="fas fa-chart-bar mr-1"></i>Bar Chart Example</div>
                                            <div class="card-body"><canvas id="myBarChart" width="100%" height="40"></canvas></div>
                                        </div>
                                    </div>
                                </div> */}
              </div>
            </main>
            <footer class="py-4 bg-light mt-auto">
              <div class="container-fluid">
                <div class="d-flex align-items-center justify-content-between small">
                  <div class="text-muted">
                    Copyright &copy; Adnan Ahmed 2020
                  </div>
                  <div>
                    <span href="#">Privacy Policy</span>
                    &middot;
                    <span href="#">Terms &amp; Conditions</span>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    dwOpen: state.dw,
  };
};

export default withRouter(connect(mapStateToProps, null)(Admin));
